// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hoverb:hover {
    transform: scaleX(1.04) scaleY(1.04); /* Increase size by 5% */
    transition: transform 0.3s ease-in-out; /* Apply transition */
    /* text-decoration: underline; */
    /* color:blue */
  }
  
 
  
  .hoverb {
    transition: transform 0.3s ease-in-out; /* Apply transition */
  }

  @media screen and (min-width: 1400px) {
    .font-res {
      font-size: 3.4rem;
    }
  }

    .font-color-trans {
      background-clip: text;
      background: linear-gradient(
        to right,
        #7407FF,
        #9C2CC5,
        #C65286,
        #E16C5C,
        #FF8730
      );
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  
    @media screen and (max-width: 767px) {
      .wrapSubCardpd{
          flex-wrap: wrap;
          justify-content: space-between;
          margin-top: 50px;
          margin-bottom: 50px;
        }
        .textM{
          margin-left: 0px;
          margin-right: 0x;
          margin-top: 30px;
          text-align: center;
        }
        .imgM{
          align-self: center;
        }
        
  }
  @media screen and (min-width: 768px) {
      .wrapSubCardpd{
          flex-wrap: nowrap;
          justify-content: space-between;
          margin-top: 30px;
          margin-bottom: 30px;
        }
        .textM{
          margin-left: 20px;
          margin-right: 0x;
          text-align: start;
        }
        .imgM{
          align-self: start;
        }
  }
 `, "",{"version":3,"sources":["webpack://./src/Components/PodcastersDetails/assets/podcast.css"],"names":[],"mappings":"AAAA;IACI,oCAAoC,EAAE,wBAAwB;IAC9D,sCAAsC,EAAE,qBAAqB;IAC7D,gCAAgC;IAChC,eAAe;EACjB;;;;EAIA;IACE,sCAAsC,EAAE,qBAAqB;EAC/D;;EAEA;IACE;MACE,iBAAiB;IACnB;EACF;;IAEE;MACE,qBAAqB;MACrB;;;;;;;OAOC;MACD,6BAA6B;MAC7B,oCAAoC;IACtC;;IAEA;MACE;UACI,eAAe;UACf,8BAA8B;UAC9B,gBAAgB;UAChB,mBAAmB;QACrB;QACA;UACE,gBAAgB;UAChB,gBAAgB;UAChB,gBAAgB;UAChB,kBAAkB;QACpB;QACA;UACE,kBAAkB;QACpB;;EAEN;EACA;MACI;UACI,iBAAiB;UACjB,8BAA8B;UAC9B,gBAAgB;UAChB,mBAAmB;QACrB;QACA;UACE,iBAAiB;UACjB,gBAAgB;UAChB,iBAAiB;QACnB;QACA;UACE,iBAAiB;QACnB;EACN","sourcesContent":[".hoverb:hover {\n    transform: scaleX(1.04) scaleY(1.04); /* Increase size by 5% */\n    transition: transform 0.3s ease-in-out; /* Apply transition */\n    /* text-decoration: underline; */\n    /* color:blue */\n  }\n  \n \n  \n  .hoverb {\n    transition: transform 0.3s ease-in-out; /* Apply transition */\n  }\n\n  @media screen and (min-width: 1400px) {\n    .font-res {\n      font-size: 3.4rem;\n    }\n  }\n\n    .font-color-trans {\n      background-clip: text;\n      background: linear-gradient(\n        to right,\n        #7407FF,\n        #9C2CC5,\n        #C65286,\n        #E16C5C,\n        #FF8730\n      );\n      -webkit-background-clip: text;\n      -webkit-text-fill-color: transparent;\n    }\n  \n    @media screen and (max-width: 767px) {\n      .wrapSubCardpd{\n          flex-wrap: wrap;\n          justify-content: space-between;\n          margin-top: 50px;\n          margin-bottom: 50px;\n        }\n        .textM{\n          margin-left: 0px;\n          margin-right: 0x;\n          margin-top: 30px;\n          text-align: center;\n        }\n        .imgM{\n          align-self: center;\n        }\n        \n  }\n  @media screen and (min-width: 768px) {\n      .wrapSubCardpd{\n          flex-wrap: nowrap;\n          justify-content: space-between;\n          margin-top: 30px;\n          margin-bottom: 30px;\n        }\n        .textM{\n          margin-left: 20px;\n          margin-right: 0x;\n          text-align: start;\n        }\n        .imgM{\n          align-self: start;\n        }\n  }\n "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
